import { Link } from "react-router-dom";
import { ArrowUpRight, Target, Compass, Award } from "lucide-react";
import { company, stats } from "../data";

export default function About() {
  return (
    <main data-testid="about-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-20">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / about / cea india
        </p>
        <h1 className="h-display text-5xl md:text-7xl max-w-[18ch]">
          Built by engineers, for <span className="text-signal-amber">engineers.</span>
        </h1>
      </section>

      <section className="section-padding py-20 grid grid-cols-1 lg:grid-cols-12 gap-12 border-b border-ink-700">
        <div className="lg:col-span-5">
          <p className="overline mb-3">// The story</p>
          <h2 className="h-display text-3xl md:text-4xl mb-6">Founded 2013, in Patna.</h2>
        </div>
        <div className="lg:col-span-7 space-y-6 font-mono text-sm text-textmuted leading-relaxed">
          <p>{company.description}</p>
          <p>
            From a small workshop in Kesari Nagar, CEA has grown into a multi-state
            supplier, with offices in Patna and Pune. We supply trainer kits to
            engineering colleges, components to industrial assembly lines, and
            automation systems to commercial campuses.
          </p>
          <p>
            Our team brings hands-on electronics expertise — every product on our
            catalogue is one we would happily install in our own bench. That bias
            for engineering quality is what keeps clients coming back.
          </p>
        </div>
      </section>

      <section className="border-b border-ink-700">
        <div className="grid grid-cols-2 md:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={s.code}
              className={`p-8 lg:p-10 ${i < stats.length - 1 ? "md:border-r" : ""} border-ink-700 ${
                i < 2 ? "border-b md:border-b-0" : ""
              } ${i === 1 ? "border-r md:border-r" : ""}`}
            >
              <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-signal-phosphor mb-3">
                {s.code}
              </p>
              <p className="font-display font-black text-4xl md:text-5xl leading-none">{s.value}</p>
              <p className="mt-2 font-mono text-xs text-textmuted uppercase tracking-widest">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-padding py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 grid-cells">
          {[
            { icon: Target, title: "Mission", body: company.mission },
            {
              icon: Compass,
              title: "Approach",
              body: "We work as a team to deliver high-quality services and products — and to maintain a professional business relationship with every client.",
            },
            {
              icon: Award,
              title: "Promise",
              body: "100% satisfaction. Every order. From sample dispatch to lab commissioning.",
            },
          ].map((b) => {
            const Icon = b.icon;
            return (
              <div key={b.title} className="p-8 lg:p-10 hover-lift">
                <Icon size={22} strokeWidth={1.5} className="text-signal-amber mb-6" />
                <p className="font-display font-bold text-xl mb-3">{b.title}</p>
                <p className="font-mono text-xs text-textmuted leading-relaxed">{b.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 flex justify-center">
          <Link to="/enquiry" className="btn-primary" data-testid="about-cta">
            Start a conversation <ArrowUpRight size={14} />
          </Link>
        </div>
      </section>
    </main>
  );
}
